export default {
  home: '首页',
  document_title: 'IP广播对讲软件',
  document_title_fusion: 'IP指挥调度软件',
  login_title: 'IP广播对讲软件',
  login_title_fusion: 'IP指挥调度软件',
  login: '登录',
  logining: '登录中...',
  login_success:'登录成功',
  login_fail:'登录失败',
  not_open_fast_login:'快捷登录未开启',
  open:'开启',
  close:'关闭',
  dispatch: '调度控制台',
  setting: '设置',
  user_setting: '个人设置',
  full_screen: '全屏',
  logout: '退出',
  otherLogin: '异地登录',
  loginError: '用户名或密码错误！',
  systemIsUpgrade: '系统正在升级中，请稍候！',
  reLoginTitle: '账号重复登录',
  reLoginContent: '该账号已经登录，是否注销上一个登录，并登录？',
  unknown_error: '未知错误',
  update_password: '修改密码',
  old_pass: '旧密码',
  new_pass: '新密码',
  again_pass: '确认密码',
  old_pass_placeHolder: '请输入旧密码',
  new_pass_placeHolder: '请输入新密码',
  again_pass_placeHolder: '请再次输入新密码',
  password_error: '密码至少6位,同时包含字母和数字',
  password_error1: '原密码错误',
  password_error2: '两次输入密码不一致',
  searchTip: '输入关键字搜索',
  searchTime: '请选择时间',
  search: '搜索',
  total: '共',
  item: '条',
  sure: '确认',
  cancel: '取消',
  upload: '上传',
  collapsed: '展开/收起',
  exportFile: '导出',
  importFile: '导入',
  exportTemp: '下载导入模板',
  no_data: '无数据',
  conf_displayNum: '系统中未配置会议显示号码',
  file: '文件',
  info: '太大，超过10M',
  format_err: '格式不正确，请选择jpg，jpeg或png',
  operate_success: '操作成功!',
  operate_complete: '操作完成!',
  operate_fail: '操作失败!',
  exten_change: '分机状态改变，请重新登录！',
  exten_offline: '分机不在线或分机忙碌',
  success: '成功',
  fail: '失败',
  unknown: '未知',
  unsend: '未发送',
  yes: '是',
  no: '否',
  multiple: '多选',
  single: '单选',
  col: '列',
  row: '行',
  enable: '启用',
  disable: '不启用',
  isNumber: '不是数字',
  no_select_exten: '待选分机',
  selected_exten: '已选分机',
  noData: '暂无数据',
  exten: '分机号',
  outLine: '未知',
  calling_pre: '来电号码',
  caller_pre: '被叫号码',
  fileError: '文件格式错误',
  server_error: '服务器错误！',
  enter_name: '请输入用户名',
  enter_password: '请输入密码',
  enter_code: '请输入验证码',
  name_null: '用户名不能为空',
  password_null: '密码不能为空',
  code_null: '验证码不能为空',
  code_title: '点击刷新',
  code_success: '验证码正确',
  code_fail: '验证码错误',
  message_error: '消息错误',
  title: 'IP广播对讲软件',
  is_auto_accept: '自动接听',
  auto_type: '接听方式',
  webRtc_auto: '默认',
  webRtc_audio: '语音',
  webRtc_video: '视频',
  console_video_button:'视频按钮',
  video_call: '视频通话',
  audio_accept: '语音接听',
  audio_call_out: '语音呼出',
  video_call_out: '视频呼出',
  video_accept: '视频接听',
  call_tip: '呼叫来电',
  call_type: '呼叫方式',
  answer_call: '接听',
  reject_call: '拒接',
  call_content: '电话:',
  call_content_append: ',来电！',
  control: '主控台',
  no_exten_inline: '无控制分机在线',
  control_busy: '控制话机繁忙',
  call: '呼叫',
  left_mobile: '左话机',
  right_mobile: '右话机',
  inline: '在线',
  offline: '离线',
  talk: '通话',
  ring: '振铃',
  answer: '应答',
  handup: '挂断',
  terminal_number: '终端号码',
  terminal_name: '终端名称',
  terminal_ip: '终端IP',
  callee_queue: '来电队列',
  caller_queue: '当前通话',
  enterqueue: '进入队列',
  leavequeue: '离开队列',
  and: ' 与 ',
  unanswer: '未接来电',
  unanswer_time: '呼叫时间',
  current_area: '当前区域',
  partition_conf: '分区会议',
  partition_pag: '分区喊话',
  partition_broad: '分区广播',
  device_station: '终端分区',
  device_name: '终端名称',
  device_station_small: '位置',
  device_name_small: '名称',
  device_dept: '所属分区',
  intercom: '对讲',
  hangup: '挂断',
  monitor: '监听',
  barge: '强插',
  take_over: '拆讲',
  secret: '密语',
  transfer: '转接',
  more_conf: '多方会议',
  more_broad: '多方广播',
  more_pro: '多方喊话',
  group_info: '组织信息',
  all_area: '全部分区',
  private: '私有',
  only_admin: '仅管理员可见',
  sure_ebs: '播放/停止 ?',
  play: '播放',
  stop: '停止',
  no_bro: '无紧急广播任务',
  stop_bro: '紧急广播未启用',
  Idle: '空闲',
  Idel: '空闲',
  Talking: '通话',
  Ringing: '振铃',
  OffLine: '离线',
  UnKnow: '未知',
  UnKnown: '未知',
  Broading: '广播',
  unSelectExt: '请选择终端',
  unCheckExt: '请勾选终端',
  checkOffLineExt: '请选择支持离线的终端',
  unCheckOffLineExt: '请勾选支持离线的终端',
  conference: '会议室',
  videoConference: '视频会议',
  broadcast: '广播任务',
  broad_type: '广播类型',
  time_broad: '定时任务',
  state_broad: '运行状态',
  state_exten: '设备状态',
  state_bro: '进行中任务',
  all_broad: '全部任务',
  music_broad: '音乐任务',
  pro_broad: '喊话任务',
  word_broad: '文字任务',
  see_broad: '采播任务',
  outside_broad: '外部任务',
  file_broad: '文件任务',
  offline_broad: '离线任务',
  broad_plan: '广播方案',
  broad_log: '广播记录',
  change_plan: '方案切换',
  music_broad_not_suffix: '音乐',
  pro_broad_not_suffix: '喊话',
  word_broad_not_suffix: '文字',
  see_broad_not_suffix: '采播',
  file_broad_not_suffix: '文件',
  offline_broad_not_suffix: '离线',
  broad_pstn: '接入号',
  broad_status: '状态',
  broad_task: '类型',
  broad_model: '模式',
  broad_time: '播放时间',
  broad_order: '播放模式',
  broad_priority: '优先级',
  broad_tone: '提示音',
  broad_volumn: '音量',
  broad_pro: '进度',
  one_level: '超紧急',
  two_level: '高',
  three_level: '中',
  four_level: '低',
  nostart_status: '未开始',
  start_status: '开始',
  play_status: '进行中',
  end_status: '结束',
  pause_status: '暂停',
  sending: '下发中',
  send_complete: '下发完成',
  part_fail: '部分失败',
  model_one: '即时广播',
  model_two: '定时广播',
  model_three: '触发广播',
  model_four: '离线广播',
  model_one_not_suffix: '即时',
  model_two_not_suffix: '定时',
  model_three_not_suffix: '触发',
  order_model: '顺序',
  random_model: '随机',
  cir_model: '循环',
  no_cir_model: '不循环',
  end: '结束',
  delete: '删除',
  volume: '音量',
  add: '添加',
  batchDelete: '批量删除',
  confirm_delete: '确认删除',
  confirm_delete_record: '确定要删除这条抓拍记录吗？',
  confirm_delete_video_record: '确定要删除这条录像记录吗？',
  delete_success: '删除成功',
  delete_fail: '删除失败',
  select_record_first: '请先选择要删除的记录',
  confirm_batch_delete: '确认批量删除',
  confirm_batch_delete_records: '确定要删除选中的 {count} 条记录吗？',
  confirm_delete_search_records: '确定要删除搜索结果中的所有记录吗？',
  batch_delete_success: '批量删除成功',
  batch_delete_fail: '批量删除失败',
  update: '编辑',
  copy:'复制',
  no_operate: '不能操作',
  every: '每',
  week_one: '周一',
  week_two: '周二',
  week_three: '周三',
  week_four: '周四',
  week_five: '周五',
  week_six: '周六',
  week_seven: '周日',
  no_select_bro: '请选择广播',
  select_more_bro: '请选择一条广播!',
  has_unsupport_exten: '含有不支持离线的分机',
  task_sync_complete: '同步完成',
  task_sync_renew: '已重新同步',
  task_sync_fail: '同步失败',
  no_start_bro: '广播未开始',
  delete_bro: '删除广播?',
  /*broad form*/
  broadName: '广播名称',
  broadPriority: '优先级',
  broadPlayNum: '播放次数',
  broadPstn: '广播接入号',
  broadTone: '提示音',
  broadAccessPw: '接入号密码',
  broadType: '广播类型',
  broadVolumn: '音量',
  broadOrder: '排序',
  broadValidity: '任务有效期',
  permanentValidity: '永久有效',
  placeholderValidity: '请选择有效期',
  broadTime: '播放时长',
  broadPlayQueue: '播放列表',
  musicQueue: '音乐列表',
  broadPlayType: '播放方式',
  broadUpdateFile: '上传文件',
  broadMusic: '音乐文件',
  notice_content:'提示内容',
  placeholderMusic: '请选择音乐文件',
  placeholderText: '请选择txt格式文件',
  placeholder_notice:'请输入提示内容',
  uploadMusic: '上传音乐文件',
  musicName: '音乐名称',
  musicPath: '音乐文件',
  musicRemark: '音乐备注',
  musicVolume: '音乐音量',
  placeholderMusicName: '请输入音乐名称',
  placeholderMusicPath: '请上传音乐文件',
  placeholderMusicRemark: '请输入音乐备注',
  placeholderMusicVolume: '请选择音乐音量',
  placeholderOrder: '请输入排序',
  musicNameEmpty: '音乐名称不能为空',
  musicFileEmpty: '音乐文件不能为空',
  musicVolumeEmpty: '音乐音量不能为空',
  broadText: '文字内容',
  broadSee: '采播终端',
  broadFileType: '播放类型',
  placeholderBroadType: '请选择播放类型',
  tts: '文档',
  voice: '语音',
  txt_content: '文本内容',
  txt_file: '文本文件',
  vioce_file: '语音文件',
  broadTimeType: '定时方式',
  broadFixedTime: '固定时间',
  broadWeekly: '按周循环',
  /*form placeHolder*/
  bnameplaceHolder: '请输入广播名称',
  bpriorityplaceHolder: '请选择优先级',
  bplayNumplaceHolder: '请输入广播次数',
  bpstnplaceHolder: '请选择接入号',
  btoneplaceHolder: '请选择提示音',
  baccessPwplaceHolder: '请输入接入号密码',
  btypeplaceHolder: '请选择广播类型',
  btimeplaceHolder: '请输入广播时长（分钟）',
  bplayQueueplaceHolder: '请选择播放列表',
  bplayTypeplaceHolder: '请选择播放模式',
  bseeplaceHolder: '请选择采播终端',
  buploadFileplaceHolder: '请选择文件',
  btextplaceHolder: '请输入文本',
  bfplaceHolder: '请选择播放时间',

  /*form validate*/
  name_vali: '广播名称不能为空',
  priority_vali: '广播优先级不能为空',
  play_times_vali: '播放次数不能为空',
  lasting_time_vali: '播放时长不能为空',
  capture_dev_vali: '采播终端不能为空',
  access_num_vali: '广播接入号不能为空',
  prompt_tone_vali: '广播提示音不能为空',
  access_num_pw_vali: '广播接入号密码不能为空',
  temp_volume_vali: '音量不能为空',
  play_list_id_vali: '播放列表不能为空',
  play_music_idvali: '音乐不能为空',
  playing_mode_vali: '播放模式不能为空',
  text_content_vali: '文字内容不能为空',
  exten_vali: '注：终端号不能为空',
  authority_vali: ',权限外终端不可操作',
  check_exten_vali: '请选择终端',
  file_vali: '文件不能为空',
  playing_time_vali: '广播时间不能为空',
  broadcast_time_vali: '广播时间不能为空',
  broadcast_effect_time_vali: '生效时间不能为空',
  broadcast_weekday_time_vali: '每周不能为空',
  type_vali: '广播类型不能为空',
  holiday: '节假日',
  placeholderHoliday: '请选择节假日时间',
  month: '月份',
  date: '日期',
  startTime: '开始时间',
  endTime: '截至时间',
  remark: '备注',
  same_name_vali: '广播名称已存在',
  exten_has_cross_time: '分机存在交叉时间',
  task_exten_delete_fial: '任务删除失败',
  each_week: '每周',
  effective_time: '生效时间',
  select_time: '选择时间',
  terminal_file: '终端文件',
  offline_task: '离线任务',
  edit_volume: '编辑音量',
  task_asyc: '任务同步',
  update_volume: '修改音量',
  task_asys_detail: '任务同步详情',
  broadcast_task: '广播任务',
  file_name: '文件名称',
  file_address: '文件地址',
  asyc_status: '下发状态',
  fail_reason: '失败原因',
  operation: '操作',
  retry: '重试',
  force_delete: '强制删除',
  resend: '重新下发',

  word: '文字',
  whether_open: '是否启用',
  has_open: '已启用',
  not_open: '未启用',

  searchDevice: '请输入终端号码',
  b_number: '号码',
  b_name: '名称',
  b_status: '状态',
  b_volume: '音量',
  b_ip: 'IP',
  b_mac: 'MAC',
  b_type: '类型',
  b_model: '型号',
  b_support_offline: '支持离线',
  support: '是',
  unsupport: '否',

  /**同步状态*/
  issuedStatus_0: '开始同步',
  issuedStatus_1: '同步中',
  issuedStatus_2: '已同步',
  issuedStatus_3: '同步失败',
  issuedStatus_4: '开始删除',
  issuedStatus_5: '删除中',
  issuedStatus_6: '删除失败',

  /**失败原因*/
  failReason_1: '发送失败',
  failReason_2: '响应超时',

  standGuard: '无人值守',
  transfer_phone: '来电转接号码',
  enterphone: '请输入值守号码',
  startStand: '开始无人值守',
  standing: '正在无人值守',
  cancel_stand: '取消无人值守',
  stand_error: '无人值守失败',
  phone_error: '手机号错误',
  warning: '报警',
  device_alarm: '终端报警',
  warning_type: '报警类型',
  warning_unrelease: '未解除报警',
  warning_release: '已解除报警',
  warning_level: '报警级别',
  warning_source: '报警源',
  warning_devName: '报警终端名',
  warning_status: '报警状态',
  warning_content: '报警内容',
  warning_happenTime: '报警发生时间',
  warning_releaseTime: '报警解除时间',
  warning_remark: '报警备注',
  warning_sure: '报警确认',
  warning_remove: '报警解除',
  level_one: '一级',
  level_two: '二级',
  level_three: '三级',
  status_one: '新报警',
  status_two: '已确认',
  status_three: '已解除',
  is_alarm: '是报警',
  is_unalarm: '非报警',
  no_sure_alarm: '报警未确认',
  no_select_alarm: '请选择一条报警',
  ignore: '忽略',
  video: '视频监控',
  no_support_play: '该摄像头不支持预览',
  camera: '摄像头',
  reload: '请重新加载',
  recording: '录像开始',
  stop_record: '录像结束',
  img_record: '抓拍成功',
  image_look: '抓拍记录',
  video_look: '录像记录',
  call_btn: '呼叫',
  image_record_btn: '截屏',
  image_web_record_btn: '抓拍',
  video_record_start_btn: '开始录屏',
  video_record_stop_btn: '结束录屏',
  ptz_btn: '云台控制',
  close_btn: '关闭',
  stop_rtmp: '关闭成功',
  image_name: '图片名称',
  video_name: '视频名称',
  create_date: '创建时间',
  action: '操作',
  view: '查看',
  playVideo: '播放',
  download: '下载',
  generator: '生成',
  hostInfo_tip: '生成 HostInfo',
  hostInfo_content: '此操作会生成一个新的HostInfo文件并且覆盖旧的文件。',
  view_image: '查看图片',
  view_video: '查看视频',
  no_camera: '未选择摄像头',
  message_live_scan: '扫码查看',
  camera_no_active: '摄像头未激活',
  camera_connected: '摄像头连接失败',
  no_free_windows: '未有空闲窗口，是否替换最后一个打开的窗口？',
  line_limit: '转流线数已达上限',
  map: '电子地图',
  device: '终端',
  baidu_map: '地图视图',
  diy_map: '场景视图',
  edit_map: '编辑地图',
  current_device: '当前终端',
  had_device: '终端已存在地图中',
  del_device: '删除终端',
  upload_diy: '上传场景图',
  del_content: '删除地图中',
  del_content_last: '个终端',
  select_device: '请选择图中终端',
  reserve_plan: '预案',
  reserve_plan_title:'预案',
  reporting_information: '上报信息',
  execute_plan: '是否执行预案',
  hasPlan: '预案已存在',
  delete_plan: '删除预案',
  no_select_plan: '请选择预案',
  select_more_plan: '请选择一条预案!',
  plan_type: '预案类型',
  all_plan: '全部预案',
  tamper_type: '防拆报警',
  oneKey_type: '一键报警',
  waln_type: '网关报警',
  device_empty: '终端不能为空',
  camera_empty: '摄像头不能为空',
  trigger_one: '自动',
  trigger_two: '手动',
  trigger_three: '关闭',
  plan_device_name: '终端/摄像头名称',
  part_name: '分区/端口',
  alarm_type: '报警类型',
  trigger_mode: '触发模式',
  alarm_type_placeHolder: '请选择报警类型',
  trigger_mode_placeHolder: '请选择触发模式',
  placeholder_camera: '请选择摄像头',

  plan_link_modal: '预案联动',
  linkPlan: '联动',
  haikang: '海康',
  dahua: '大华',
  sanli: '金三立',
  fangwei: '方位',
  other: '其他',
  broad: '广播',
  sms: '短信',
  sms_phone: '短信号码',
  sms_content: '短信内容',
  editable: '短信模板可编辑项不能为空',
  camera_name: '摄像头标识名称',
  camera_brand: '摄像头品牌',
  camera_address: 'IP 地址',
  camera_port: '端口号',
  camera_initial_count: '初始化帐号',
  exten_placeHolder: '请输入分机号',
  queuing_notice: '调度通知',
  delete_notice: '删除通知',
  notice: '通知',
  notice_type: '通知类型',
  all_notice: '全部通知',
  word_notice: '文字通知',
  record_notice: '录音通知',
  notice_access_num: '接入号码',
  notice_display_num: '显示号码',
  name: '名称',
  notice_status: '执行状态',
  notice_start_time: '启动时间',
  notice_ttype: '类型',
  notice_ntype: '方式',
  notice_model: '模式',
  notice_call_num: '呼叫数',
  notice_called_num: '已呼数',
  notice_uncall_num: '未呼数',
  notice_volume: '音量',
  notice_call_pre: '已呼率',
  notice_uncall_pre: '未呼率',
  notice_accept_pre: '已接率',
  one_type: '即时通知',
  two_type: '定时通知',
  three_type: '触发通知',
  detail: '详情',
  select_more_notice: '请选择一条通知',
  no_select_notice: '请选择通知',
  detail_modal: '详细信息',
  index: '序号',
  tel: '号码',
  start_time: '开始时间',
  ring_time: '振铃时间',
  answer_time: '应答时间',
  hangup_time: '挂断时间',
  call_result: '呼叫结果',
  send_result: '发送结果',
  call_status: '呼叫状态',
  call_count: '呼叫次数',
  call_out: '已呼出',
  call_answer: '客户应答',
  call_hang: '客户挂断',
  notice_name: '通知名称',
  retry_num: '重试次数',
  concurrency_num: '并发线数',
  concurrency_num_check: '并发线数建议填写1-9999',
  redial_times_check: '重试次数建议填写0-99',
  notice_access: '通知接入号',
  notice_access_pw: '接入号密码',
  notice_display: '显示号码',
  ring_times: '振铃时长',
  sys_tel: '系统号码',
  file_tel: '导入号码',
  file_tip: '(","分隔号码的txt文件)',
  record_file: '录音文件',
  notice_text: '文字内容',
  select_type: '号码选择方式',
  notice_tel: '已选号码',
  tel_tip: '(","分隔号码)',
  is_use: '是否启用',
  is_mpa: 'MP3高音质',
  recv_btn: '按键采集',
  btn_val: '按键',
  notice_end: '按键确认提示音',
  endPlaceholder: '请选择按键确认提示音',
  nnplaceholder: '请输入通知名称',
  nrplaceholder: '请输入重试次数',
  ncplaceholder: '请输入并发数',
  naplaceholder: '请选择接入号',
  ndplaceholder: '请选择显示号码',
  napplaceholder: '请输入接入号密码',
  nrtplaceholder: '请输入振铃时长',
  ntplaceholder: '请选择通知类型',
  nrfplaceholder: '请选择录音文件',
  ntcplaceholder: '请输入文字内容',
  ntsplaceholder: '请输入通知号码',
  n_sms_vali: '短信不能为空',
  n_name_vali: '通知名称不能为空',
  n_retry_vali: '重试次数不能为空',
  n_type_vali: '类型不能为空',
  n_max_vali: '并发线数不能为空',
  n_pstn_vali: '接入号不能为空',
  n_pass_vali: '接入号密码不能为空',
  n_d_vali: '显示号码不能为空',
  n_r_vali: '振铃时长不能为空',
  n_record_vali: '录音文件不能为空',
  n_text_vali: '文字内容不能为空',
  n_exten_vali: '通知号码不能为空',
  n_time_vali: '通知时间不能为空',
  n_week_vali: '循环时间不能为空',
  n_access_num_vali: '通知接入号不能为空',
  sys_ext: '系统分机',
  address_book: '通讯录',
  contacts: '通讯录',
  linkman_group: '分组列表',
  linkman_name: '联系人名称',
  linkman_phone: '联系人电话',
  linkman_groupname: '分组名',
  linkman_vip: 'VIP',
  linkman_remark: '备注',
  linkman_self: '类型',
  send: '发送',
  sendMsg: '发送短信',
  sendFilter: '发送过滤',
  sendSelect: '按选择结果发送',
  sendSearch: '按搜索结果发送',
  selecttemplate: '短信模板',
  sendData: '发送内容',
  pleaseSelect: '请选择',
  pleaseInput: '请输入',
  all_link: '全部联系人',
  sendContentNull: '发送内容不能为空',
  sendPhoneNull: '发送的号码不能为空',
  sendFail: '发送失败',
  sendSuccess: '发送成功',
  sendTypeNull: '发送类别不能为空',
  notice_fun: '通知方式',
  smsType: '短信通知',
  voiceType: '语音通知',
  smsAndVoiceType: '语音及短信通知',
  noAnswerSmsType: '未接通短信通知',
  l_linkman_name_empty: '联系人名称不能为空',
  l_link_phone_empty: '联系人电话不能为空',
  l_linkman_phone_empty: '联系人电话不能为空',
  l_group_empty: '分组不能为空',
  l_vip_empty: 'VIP不能为空',
  l_link_group_name_empty: '分组名称不能为空',
  l_link_group_name_exist: '分组名已存在',
  broad_link: '广播联动',
  video_link: '视频联动',
  video_link_max: '视频联动数量已达最大',
  get_video: '获取视频地址出错',
  sms_link: '短信联动',
  no_svl: '请选择一条视频联动',
  no_ssl: '请选择一条短信联动',
  broad_name_placeHolder: '请选择广播任务',
  video_name_placeHolder: '请选择摄像头',
  sms_phone_placeHolder: '请输入短信号码',
  sms_content_placeHolder: '请输入短信内容',
  select_more_group: '请选择一条分组',
  no_select_group: '未选择分组',
  cameraname_placeHolder: '请输入摄像头名称',
  lname_placeHolder: '请输入联系人名称',
  lphone_placeHolder: '请输入联系人号码',
  lgroup_placeHolder: '请选择分组',
  lvip_placeHolder: '请选择',
  lremark_placeHolder: '请输入备注',
  select_more_link: '请选择一个联系人',
  no_select_link: '未选择联系人',
  delete_linkman: '删除联系人',
  group: '分组',
  group_btn: '分组',
  group_manager: '联系人分组管理',
  delete_group: '删除分组',
  delete_ginfo: '，以及分组下的所有联系人',
  lgname_placeHolder: '请输入分组名称',
  no_link_phone: '联系人无号码',
  link_phone_error: '联系人号码不正确',
  system: '系统管理',
  emergency: '紧急广播',
  emergency_running:'播放中',
  edition_title: 'IP广播对讲软件',
  edition_title_fusion: 'IP指挥调度软件',
  user_account: '账号',
  agent_extension: '座席分机',
  curr_time: '当前时间',
  serverunconnected: '服务器未连接',
  serverconnected: '服务器已连接',
  components: '组件',
  count_to_page: '数字渐变',
  tables_page: '多功能表格',
  split_pane_page: '分割窗口',
  markdown_page: 'Markdown编辑器',
  editor_page: '富文本编辑器',
  icons_page: '自定义图标',
  img_cropper_page: '图片编辑器',
  join_page: 'QQ群',
  doc: '文档',
  update_table_page: '上传CSV文件',
  update_paste_page: '粘贴表格数据',
  multilevel: '多级菜单',
  directive_page: '指令',
  excel: 'Excel',
  'upload-excel': '上传excel',
  'export-excel': '导出excel',
  tools_methods_page: '工具函数',
  drag_list_page: '拖拽列表',
  i18n_page: '多语言',
  modalTitle: '模态框题目',
  content: '这是模态框内容',
  buttonText: '显示模态框',
  'i18n-tip': '注：仅此页做了多语言，其他页面没有在多语言包中添加语言内容',
  error_store_page: '错误收集',
  error_logger_page: '错误日志',
  error: '错误',
  query: '带参路由',
  params: '动态路由',
  cropper_page: '图片裁剪',
  message_page: '消息中心',
  tree_table_page: '树状表格',
  org_tree_page: '组织结构树',
  drag_drawer_page: '可拖动抽屉',
  tree_select_page: '树状下拉选择器',
  welcome: '欢迎登录',
  out_full_screen: '退出全屏',
  in_full_screen: '全屏',
  fixConfGroup: '固定会议',
  temConfGroup: '临时会议',
  invite: '邀请',
  kick: '移出',
  mute: '静音',
  cmute: '取消静音',
  allmute: '全静音',
  allcmute: '取消全静音',
  cfstart: '开始会议',
  cfclose: '关闭会议',
  current_conferece: '当前会议',
  confNotOpen: '当前会议未开始',
  confIsOpen: '当前会议已开始',
  callConfList: '会议信息',
  confMember: '会议成员',
  EnterConference: '进入',
  LeaveConferce: '离开',
  MuteConference: '静音',
  CancelMuteConference: '解静',
  inconf: '在',
  Input_placeholder: '请输入',
  highInfo: '高级设置',
  baseInfo: '基本设置',
  KeyCollection: '采集按键',
  key_number: '按键数',
  not_enter_number: '未按键通知次数',
  call_lasting_time: '通话时长',
  start_tip: '启用提示',
  notice_not_start_tip: '通知未启用，是否现在启用并播放',
  broad_not_start_tip: '广播未启用，是否现在启用并播放',
  /**************上报信息 **************/
  reporting_information_is_read: '是否已读',
  reporting_information_upload_info: '上报信息',
  reporting_information_all_info: '全部信息',
  reporting_information_has_read: '已读状态',
  reporting_information_not_read: '未读状态',

  upInfo_col_index: '序号',
  upInfo_col_id: '信息ID',
  upInfo_col_title: '上报标题',
  upInfo_col_content: '上报内容',
  upInfo_col_isRead: '是否已读',
  upInfo_col_upUserName: '上报人员',
  upInfo_col_address: '上报地址',
  upInfo_col_file_path: '附件',
  upInfo_col_upTime: '上报时间',
  upInfo_col_file_comments: '评论',
  upInfo_col_baseInfo: '基本信息',
  upInfo_col_open_comments: '展开评论',
  upInfo_col_close_comments: '收起评论',
  upInfo_col_click_me: '点我跳转',
  upInfo_col_no_attach: '暂无附件',
  upInfo_col_view_detail: '详情',
  upInfo_col_has_read: '已读',
  upInfo_col_not_read: '未读',
  upInfo_col_not_support_preview: '不支持预览',
  upInfo_col_modal_not_support_preview: '暂不支持预览该文件',

  upInfo_tip_add_success: '添加成功',
  upInfo_tip_add_fail: '添加失败',
  upInfo_tip_update_success: '更新成功',
  upInfo_tip_update_fail: '更新失败',
  upInfo_tip_select_one: '请先选中一行信息',
  upInfo_tip_enter_comment: '请输入评论',
  upInfo_tip_comment_not_blank: '评论不能为空',
  upInfo_tip_comment_last_editing: '请先编辑完上一条评论',

  upInfo_action_push: '发布',
  upInfo_action_reset: '重置',
  upInfo_action_edit: '编辑',

  display_more: '更多',
  /**显示更多下的菜单名指定(采用单个英文)**/
  more_menu_control: '主控台',
  more_menu_conference: '会议室',
  more_menu_video_conference: '视频会议',
  more_menu_broadcast: '广播任务',
  more_menu_standGuard: '无人值守',
  more_menu_warning: '报警预案',
  more_menu_video: '视频监控',
  more_menu_map: '电子地图',
  more_menu_gis_map: 'GIS调度',
  more_menu_dispatch:'通讯调度',
  more_menu_channel: '频道会话',
  more_menu_reserve_plan: '预案',
  more_menu_queuing_notice: '调度通知',
  more_menu_contacts: '通讯录',
  more_menu_reporting_information: '上报信息',
  more_menu_system: '系统管理',

  // 菜单右击
  add_to_more: '添加到更多',
  move_forward: '前移',
  move_back: '后移',
  remove_more: '移出更多',
  remove_fail:'空间不足，移出失败',

  display_control: '显示终端',
  system_theme: '系统主题',

  theme_black: '黑色',
  theme_white: '白色',
  theme_blue: '蓝色',

  language: '系统语言',
  system_version: '系统版本',

  state_search: '状态筛选',
  type_search: '类型筛选',
  outCallAutoAnswer:'外置呼出自动接听',

  /*类型筛选*/
  mode_phone: '话机',
  mode_speak: '对讲',
  mode_broad: '广播',
  mode_door: '门禁',
  mode_pc: '话务台',
  mode_car: '车载台',
  mode_voice: '调音台',
  mode_view: '视频终端',
  mode_other: '其他',
  camera_type: '摄像头',
  type_label: '类型',
  sure_logout: '确认退出?',
  expire: '无效许可证，请联系管理员或登录系统管理页面更换许可',
  noLicense: '无许可证，请联系管理员或登录系统管理页面更换许可',
  license_warn:'许可证有效期剩余{day}天，请及时更新！',
  tamper_alarm: '防拆报警',
  one_alarm: '一键报警',
  gateway_alarm: '网关报警',
  motion_alarm: '移动侦测',
  helmet_alarm: '安全帽报警',

  please_select_device_dept: '请选择所属分区',

  self_check: '自检任务',
  nowSelfCheck: '即时自检',
  timerSelfCheck: '定时自检',
  selfCheck_name: '名称',
  selfCheck_status: '状态',
  selfCheck_mode: '模式',
  selfCheck_cycle: '执行周期',
  selfCheck_playTime: '执行时间',
  selfCheck_all: '检测总数',
  selfCheck_normals: '正常数',
  selfCheck_abnormals: '不正常数',
  selfCheck_enable: '启用',
  self_check_excute: '执行',
  self_check_result: '自检结果',
  self_check_time:'自检时间',
  self_check_current_result: '最新结果',
  self_check_history_result: '历史结果',
  no_select_self_check: '请选择自检任务',
  self_check_update_title: '编辑自检任务',
  self_check_add_title: '添加自检任务',
  self_fixed_time: '固定',
  self_cycle_time: '循环',
  self_result_nostart: '未开始',
  self_result_checking: '自检中',
  self_result_normal: '正常',
  self_result_abnormal: '异常',
  self_fail_tip: '说明',
  self_result_uptime: '结束时间',
  self_result: '自检结果',
  self_name: '设备名',
  self_fail_device: '设备异常',
  self_fail_offline: '设备离线',
  self_fail_overtime: '设备超时',
  self_fail_busy: '设备忙碌',
  self_check_exist: '自检任务已存在',
  self_check_name: '自检名称不能为空',
  self_check_extens: '自检终端不能为空',
  self_check_deptId: '分区不能为空',
  video_conference_no_limit: '视频会议方数已达上限',

  //通知
  system_notice: {
    title: {
      warn: '数据预警通知',
      delete: '数据删除通知',
      selfCheck: '自检异常',
      change: 'HA通知',
      alarm: '报警预案通知'
    },
    turnToClean: '点击跳转清理',
    turnToDetail: '点击查看详情',
    turnToHA: '点击查看HA状态',
    self: {
      device: '终端',
      abnormal: '异常'
    },
    operator: {
      backing: '系统正在备份中，请勿操作',
      reset: '系统正在还原中，请勿操作',
      reboot: '系统正在初始化中，请勿操作',
      upgrade: '系统正在升级中，请勿操作',
    }
  },

  public: '公有',
  self: '私有',
  all_group: '全部分组',

  device_offline: '终端不在线',
  no_broad_menu: '无调度权限',
  dept: '分区',
  start_plan: '触发预案',
  stop_plan: '停止预案',
  conf: '会议',
  notice_link: '通知联动',
  conf_link: '会议联动',
  voice_conf_link: '语音会议联动',
  conf_name: '会议名称',
  hourly_chime: '整点报时',
  hourly_chime_exits: '报时任务已存在',
  cascade_manager: '级联管理',
  chime_play_time: '执行时间',
  chime_time_line: '播报时间段',
  placeholderTimeLine: '请选择播报时间段',
  chime_time_name: '报时任务名称不能为空',
  chime_time_terminal: '报时终端不能为空',
  timeLineEmpty: '播报时间段不能为空',
  no_select_chime_task: '请选择报时任务',
  chime_task: '报时任务',
  add_chime_task: '添加整点报时任务',
  update_chime_task: '编辑整点报时任务',
  tips: '提示',
  only_number: '只能输入数字',
  page_count_overflow: '不能超过当前最大页面,已自动查询最后一页',
  greater_than: '大于',
  less_than: '小于',
  greater_than_or_equal: '大于等于',
  less_than_or_equal: '小于等于',
  equal: '等于',

  link_phone_tips: '联系人号码需7位以上才可在固定会议室被邀请',
  plan_has_no_link: '预案未添加联动,请先添加联动',
  plan_has_link: '预案联动已存在',
  jump_to: '跳至',
  page: '页',
  app_login: '抱歉，您非本系统用户！',
  broadTimeAndCom: '播放时长(分)',
  no_system_menu: '无系统管理权限',
  is_open: '已启用',
  is_closed: '未启用',
  dept_alarm: '启动报警',
  dept_clear: '关闭报警',
  output_port: '输出口',
  enter_manager: '进入管理',
  show_all_child: '显示所有下级数据',
  broad_overview: '广播概览',
  cascade_all: '全部广播',
  cascade_running: '进行中广播',
  cascade_offline: '离线广播',
  cascade_text: '文字广播',
  cascade_shout: '喊话广播',
  cascade_music: '音乐广播',
  cascade_timing: '定时广播',
  default_time: '默认时间',
  no_default_time:'请选择默认时间',
  employee_state: '终端状态',
  system_area: '系统区域',
  change_fresh_time: '数据刷新',
  fresh_success: '刷新成功',
  fresh_fail: '刷新失败',
  every_part: '每隔',
  second_refresh: '秒刷新',
  seconds: '秒',
  cascade_tip_one: '级联管理中的概况数据刷新时间间隔，默认5秒',
  cascade_tip_two: '勾选后显示选中的及其所有下级系统的数据',
  un_register: '未注册',
  add_broad: '新建广播',
  select_bro: '选择广播',
  to_be_select_broad: '待选广播',
  selected_broad: '已选广播',
  delete_broad_plan: '删除方案?',
  enable_plan_tips: '系统中仅可启用一条方案,是否覆盖目前已启用方案?',
  plan_name_not_empty: '名称不能为空',
  select_holiday_time:'请选择节假日起始日期',
  select_start_time: '请选择开始时间',
  select_end_time: '请选择结束时间',
  broad_day: '按天循环',
  every_day: '每天',
  broad_not_enable: '当前广播已被以下方案使用，请移出后再次启用',
  broad_plan_not_delete: '当前方案已被方案切换使用，无法刪除',
  broad_plan_not_enable: '当前方案已被方案切换使用，无法启用',
  time_have_same: '当前时间和其余数据存在交集，请更改时间',
  edit_not_enable: '当前广播已被以下方案使用，默认未启用',
  not_null: '不能为空',
  start_big_end: '结束时间不能小于开始时间',

  grade_register: '系统已注册',
  grade_online: '系统在线未注册',
  grade_offline: '系统离线',
  grade_main_system: '主系统',
  video_surveillance: '监视',
  plan_exist: '广播方案已存在',
  broad_not_delete: '当前广播已被以下方案使用，无法刪除',
  current_video_call: '当前视频通话',
  surveillance_video: '监视视频',
  caller: '主叫号',
  callee: '被叫号',
  systemForCascade: '系统',

  already_exists: '已存在',
  sys_offline: '系统不在线未获取到数据',
  broad_cascade: '级联广播',
  delete_cascade: '级联广播会将子系统广播删除，是否继续？',
  outside_system: '外部系统',
  add_cascade: '已选分机树中存在不在线的系统未获取到分机数据，是否继续保存！',
  system_role: '未拥有系统管理权限，请联系管理员设置角色权限',
  same_name_notice: '通知名称已存在',
  content_too_long: '文字内容超长',
  audio_not_support: '文件不支持MP3高音质，请重新上传',
  terminal_not_allowed: '采播终端不允许在喊话终端列表中',
  textType: '文字消息通知',
  out_of_authority: '权限外',
  start: '启动',
  send_status: '发送状态',
  text_is_too_long: '文字内容不能超过500字节',
  text_is_send: '已发送的文字通知不允许编辑',
  text_have_character: '文字内容不允许包含 “|”',
  text_have_content: '文字内容不允许包含xml格式的 “content”',
  camera_foreach: '轮巡摄像头',
  please_setting_camera: '请配置轮巡摄像头',
  enable_camera: '启用轮巡',
  camera_time_interval: '轮巡间隔(秒)',
  not_select_camera: '待选摄像头',
  selected_camera: '已选摄像头',
  time_no_lg: '间隔时间不能小于5秒',
  is_opening: '当前正在轮巡中',
  is_not_two_page: '摄像头不足两组,轮巡自动关闭',
  is_loading_data: '数据加载中，请稍候',
  pause_robin: '暂停轮巡',
  resume_robin: '恢复轮巡',
  gateway_output: '网关输出口',
  port_name: '端口名称',
  un_select_port: '请选择端口',

  broad_mpa: '1.广播源文件高于320kbps采样率时，该广播语音文件以320kbps采样率播放，当源文件低于320kbps采样率时，该广播语音文件按实际采样率播放。\n' +
    '2.已选终端不支持MPA编码无法接通MP3高音质广播。\n' +
    '3.MP3高音质广播不支持广播下级级联终端。\n' +
    '4.MP3高音质广播不支持调节音量。\n' +
    '5.于2.2.7版本之前上传的音乐文件，不支持MP3高音质，开启后会出现无声现象。',
  video_isRecording: '该视频正在录屏中，是否停止录屏并关闭？',
  camera_recording: '该摄像头正在录屏中',
  broad_start_file: ' 广播开始提示音',
  no_quick_operate: '请勿频繁操作',
  epx_name: 'EPX配置管理系统',
  password_old_tip: '为了系统安全，请修改系统初始密码，是否立即修改？',
  system_tip: '系统提示',
  modify_now: '立即修改',
  next_modification: '下次修改',
  broad_user: '调度员',
  voice_meeting: '语音会议',
  video_meeting: '视频会议',
  video_out_license: '视频会议超出成员上限',
  upload_music_file: '上传语音文件',
  meeting: {
    record: {
      pre: '会议室：',
      stop: '停止录像',
      start: '开始录像',
      not_stop: '录像不能关闭',
    },
    content: {
      record: '录像',
      nick: '昵称',
      ip: 'IP',
    },
    warning: {
      in_room: '您已在会议室：${roomName}！'
    },
    btn: {
      no_select: '未选中会议室',
      setting: '设置',
      full: '全屏',
      join: '加入',
      leave: '退出',
      disableCamera: '禁用摄像头',
      enableCamera: '启用摄像头',
    },
    setting: {
      camera: '摄像头',
      mic: '麦克风',
      speak: '扬声器',
      check:'请检查',
      permission:'权限'
    },
    right: {
      meeting: '开会中',
      unMeeting: '未加入'
    },
    invite: {
      title: '视频会议邀请',
      content_pre: '调度员：',
      content_suf: '，邀请您加入视频会议：',
      join: '加入',
      reject: '拒绝'
    },
    share:{
      info:'共享屏幕',
      start:'开始共享屏幕',
      end:'结束共享屏幕',
      no_access:'您无权结束共享',
      sharing:'正在共享屏幕',
    },
    push:{
      info:'推送',
      title:'推送视频流'
    }
  },
  gis_map: {
    map: {
      name:'地图名称',
      order:'地图排序',
      img:'地图',
      manager: '底图管理',
      max_zoom: '地图已放大到最大',
      min_zoom: '地图已缩小到最小',
      start_distance: '点击地图开始测距',
      continue_distance: '单击地图继续测距或双击结束测距',
      continue_fence: '单击地图继续绘制或双击结束绘制',
      modify: '拖动修改测距',
      update_success: '更新终端位置成功',
      update_fail: '更新终端位置失败，请稍后重试！',
      add_success: '添加终端成功',
      add_fail: '添加终端失败，请稍后重试！',
      add_exits: '添加终端失败，终端已存在！',
      delete_success: '删除终端成功',
      delete_fail: '删除终端失败，请稍后重试！',
      load_fail: '加载终端数据失败，请稍后重试！',
      change_map: '请切换到对应的场景图下！',
      upload_success: '上传场景图成功',
      upload_fail: '上传场景图失败，请稍后重试！',
      transfer_fail: '场景图转换失败，请稍后重试！',
      uploading: '场景图上传中',
      lng: '经度',
      lat: '纬度',
      out_map: '请添加在场景图范围内！',
      review:'重置',
      browse:'浏览',
      lock:'锁定',
      unlock:'解锁',
      zoom_in:'缩小',
      zoom_out:'放大',
      distance:'测距',
      box_select:'框选',
      circle_select:'圈选',
      browse_current: '浏览',
      browse_exit: '退出浏览',
      box_select_disabled: '框选（请先退出浏览模式）',
      circle_select_disabled: '圈选（请先退出浏览模式）',
      fence:'围栏',
      upload:'上传',
      scene_manager:'底图管理',
      gltf_tip: '三维地图模型标准，存 3D 模型',
      geojson_tip: '二维地图矢量数据标准，存坐标和地理属性',
      name_required: '请填写地图名称',
      img_required: '请上传图片文件',
      gltf_required: '请上传3D模型文件或矢量数据',
      sort_required: '请填写地图排序',
      sort_must_number: '地图排序必须是数字',
      sort_more_than_zero: "排序值必须大于0",
      all_mode_edit_forbidden: '全部模式下无法编辑数据，请点击指定楼层后再操作',
      scene_not_configured: '请先在底图管理中配置场景图，再部署终端',
      webgl_unavailable: '3D地图无法加载，浏览器未开启硬件加速',
      edit_single_only: '编辑时只能选择一条数据',
      type:'底图类型',
      select_data_required: '请选择数据',
      delete_success_msg: '删除成功',
      save_success_msg: '保存成功',
      gltf_file_format_error: '请选择 .glb 或 .gltf 文件',
      add_map_title: '添加底图',
      edit_map_title: '编辑底图',
      col_name: '名称',
      col_type: '类型',
      col_username: '上传用户',
      col_sort: '排序',
      not_own_partition_map: '只能编辑或删除同一分区用户上传的底图',
      confirm_delete_maps: '确认删除已选中的 {count} 张底图：{names}？'
    },
    app_select: {
      title: 'APP用户',
      from_title: '待选用户',
      to_title: '已选用户',
      search: '请输入关键字',
    },
    select: {
      title: '选择终端',
      current_pre: '当前选择：',
      current_suf: '个终端',
      voice_conf: '语音会议',
      video_conf: '视频会议',
      multi_pro: '多方喊话',
      multi_bro: '多方广播',
      batch_delete: '批量删除',
      batch_delete_content: '确认批量删除终端？',
      no_selected: '未选中终端',
      operation_selected: '请选择需要操作的终端！',
      not_support_delete: 'App终端不支持删除'
    },
    fence: {
      setting: {
        title: '围栏设置',
        name: '名称',
        name_placeholder: '请输入围栏名称',
        time: '时间',
        time_placeholder: '请选择围栏时间范围',
        remark: '备注',
        remark_placeholder: '请输入围栏备注',
        type: {
          no_enter: '禁入',
          no_leave: '禁出'
        },
        btn: {
          add: '添加用户',
          delete: '删除用户',
          save: '保存',
          cancel: '取消'
        },
        columns: {
          name: '名称',
          number: '号码'
        },
        warn: {
          name: '围栏名称不能为空',
          start_time: '围栏开始时间不能为空',
          end_time: '围栏结束时间不能为空',
          edit: {
            success: '围栏更新成功！',
            fail: '围栏更新失败，请稍后重试！',
            exits: '围栏更新失败，围栏名称已存在！'
          },
          point: '围栏数据不能为空',
          add: {
            success: '围栏添加成功！',
            fail: '围栏添加失败，请稍后重试！',
            exits: '围栏添加失败，围栏名称已存在！'
          }
        }

      }
    },
    track: {
      play_title: '轨迹回放',
      time: '时间选择',
      speed: '移动速度',
      time_placeholder: '请选择时间范围',
      btn: {
        play: '播放',
        pause: '暂停',
        clear: '清空',
        query: '获取轨迹'
      },
      detail_title: '轨迹详情',
      lat: '维度',
      lng: '经度',
      warn: '加载轨迹出错，请稍后重试！'
    },
    position: {
      title: '当前位置',
      lng: '经度：',
      lat: '纬度：',
      time: '时间：'
    },
    overlay: {
      track: '轨迹',
      delete: '删除'
    },
    search: {
      select: '请输入终端名称或分机号',
      fence: {
        title: '电子围栏',
        name: '名称',
        time: '时间',
        number: '人数',
        type: '类型',
        no_enter: '禁入',
        no_leave: '禁出',
        delete: {
          title: '删除围栏',
          content: '确认删除围栏：',
          ok: '确认',
          cancel: '取消',
          success: '围栏删除成功！',
          fail: '围栏删除失败，请稍后重试！'
        }
      },
      warn_content: '告警记录',
    },
    warn: {
      title: '告警记录',
      columns: {
        name: '围栏名称',
        type: '围栏类型',
        member: '成员名称',
        time: '告警时间'
      },
      enter: '进入',
      leave: '离开',
      tip_title: '围栏告警',
      warn_prefix: '终端：',
      warn_s: '在',
    }
  },
  deleteBroadFail: '广播已被联动任务使用，删除失败',
  member_info: '成员信息',
  longitude: '经度',
  latitude: '纬度',
  monitorOnly: '监控',
  appUser: 'APP',
  status: '状态通知',
  status_tip:{
    status:'状态',
    device:'设备',
    time:'时间',
    content:'内容'
  },
  ext: '分机',
  online: '上线',
  extOffline: '下线',
  meetingConf: '会议',
  isLoading: '正在加载中',
  control_search: '请输入号码或名称',
  last_play_time: '最近播放时间',
  broad_log_columns: {
    name: '广播名称',
    play_time: '播放时间',
    all_number: '终端数量',
    answer_number: '接听数量',
    callee_number: '号码',
    callee_name: '名称',
    answer_time: '开始时间',
    is_answer: '通话状态',
    duration_time: '通话时长',
    hangup_reason: '挂断原因',
    answer_state:'已接通',
    no_answer_state:'未接通',
    detail: '广播记录详情'
  },
  hangup_reason: {
    user_busy: '座席忙时外呼',
    523: '黑名单',
    524: '网关离线或路由错误',
    no_answer: '客户未接通',
    normal_clearing: '正常挂断',
    no_user_response: '用户无响应',
    originator_cancel: '发起方取消',
    db_error: '数据异常',
    no_route_destination: '无路由',
    normal_unspecified: '未知异常',
    call_rejected: '被叫拒接',
    normal_temporary_failure: '盲转外线，路由错误',
    200: '正常挂机',
    fake_event: '座席掉线',
    fake_event_reload: '分机掉线',
    unknown: '未知',
    offline: '分机离线',
    manager_request: '达到限呼时长',
    outgoing_call_barred:'超出日呼限制',
    other_answer:'被代接',
  },
  input_number:'输入号码',
  call_record:'最近音视频记录',
  communication_dispatch:{
    link:'通讯录',
    dispatch:'调度组',
    conf:'分组会议',
    group:'分组'
  },
  report:{
    menu:'报表管理',
    left: {
      call_record: '通话记录',
      audio_record: '录音报表',
      shout_image: '抓图记录',
      alarm_record: '告警记录',
      status_record: '状态记录'
    },
    column:{
      call:{
        call_status:'呼叫状态',
        caller_number:'主叫号',
        caller_name:'主叫名称',
        called_number:'被叫号',
        called_name:'被叫名称',
        start_time:'开始时间',
        talk_status:'通话状态',
        duration_time:'通话时长',
        rate:'费率类型',
        money:'金额',
        hangup_reason:'挂断原因'
      },
      audio:{
        account_name:'录制账户名',
        start_time:'录制开始时间',
        caller_number:'主叫号',
        caller_name:'主叫名称',
        called_number:'被叫号',
        called_name:'被叫名称'
      },
      shout:{
        name:'图像名称',
        time:'抓图时间',
        camera_name:'摄像头标识名',
        device_name:'抓图终端'
      },
      status:{
        device_name:'终端名称',
        exten:'分机号',
        device_type: '终端类型',
        status:'类型',
        create_time:'发生时间',
        register_ip:'注册IP',
        register_port:'端口'
      },
      search:{
        call:{
          coming:'呼入',
          outing:'呼出',
          inside:'内线',
          answer:'已接通',
          no_answer: '未接通'
        }
      }
    },
    btn:{
      export:'导出',
      batch_download:'批量下载',
      batch_delete:'批量删除',
      download_audio:'下载录音',
      play_audio:'播放录音',
      download_video:'下载录像',
      play_video:'播放录像',
      delete:'删除',
      download_image:'下载截图',
      view_image:'查看截图'
    },
    filter:{
      label:'条件筛选',
      value1:'按选择结果',
      value2:'按搜索结果'
    },
    model: {
      title1: '导出记录',
      title2: '批量下载',
      title3: '批量删除',
      title4: '删除录音',
      title5: '查看',
      content1: '确认删除此录音？',
      title6: '删除告警记录',
      content2: '确认删除？',
    },
    tip: {
      no_select: '请选择数据',
      no_data: '无录音或录像',
    },
    name:{
      broadcast:'广播',
      announce:'多方喊话',
      pagegroup:'组播模式广播',
      conference:'会议'
    }
  },
  alarm_device: '报警终端',
  yesterday:'昨天',
  channel:'频道',
  session:'会话',
  please_input_name:'请输入频道或会话名称',
  name_too_long:'名称过长，需要在20个字符以内',
  name_exits: '名称已存在',
  chat_input_tip:'Enter发送，Shift+Enter换行',
  please_input_info:'请输入发送内容',
  emoji:'表情',
  img:'图片',
  position:'定位',
  select_member:'选择成员',
  current_member:'个成员',
  please_select_mem:'请选择成员',
  position_messages:'定位消息',
  session_detail:'会话详情',
  session_name:'会话名称',
  delete_session:'解散会话',
  exit_session:'退出会话',
  delete_member:'移出成员',
  delete_member_tip:"是否确认移出？",
  exit_session_tip:'是否确认退出会话？',
  delete_session_tip:'解散会话会将所有记录清除，是否确认？',
  upload_fail:'上传失败',
  img_upload_fail_tip:'文件格式错误，请上传JPEG/PNG/JPG/GIF格式图片。',
  img_max_tip:'超出图片大小限制，上传文件不能超过',
  audio_max_tip:'超出语音大小限制，上传文件不能超过',
  video_max_tip:'超出视频大小限制，上传文件不能超过',
  file_max_tip:'超出文件大小限制，上传文件不能超过',
  audio_type_error:'文件格式错误，请上传mp3/amr/mp4/格式文件。',
  add_member:'添加成员',
  invite_members: '邀请成员',
  to_select_mem:"待选成员",
  selected_mem:"已选成员",
  kick_member:"移出了",
  member_leave:"退出了会话",
  invite_member:"邀请了",
  change_name: '修改会话名为',
  change_channel_name:'修改了频道名为',
  create_session:'创建会话',
  member_no_operate:'成员未做操作',
  member_over:'成员超出200上限',
  channel_no_access:'无会话修改权限',
  no_member:'请选择成员',
  session_name_empty:'会话名称不能为空',
  member_search_tip:'请输入成员名称或分机号',
  el:{
    transfer: {
      noMatch: '无匹配数据',
      noData: '无数据',
      titles: ['列表 1', '列表 2'],
      filterPlaceholder: '请输入搜索内容',
      noCheckedFormat: '共 {total} 项',
      hasCheckedFormat: '已选 {checked}/{total} 项'
    },
  },
  quickButton:'快捷按键',
  quickBtn:'快捷键',
  quickButtonSetting:'快捷按键配置',
  value:'值',
  moveUp:'上移',
  moveDown:'下移',
  sureCall:'是否确认呼叫',
  sureClick:'是否确认触发',
  nullForQuickBtn:'快捷按键值为空',
  defaultOpen:'默认展开',
  access_pwd_be_number: '接入号密码必须是数字',
  quick_btn_exits:'快捷键名称已存在',
  first_one:'已移到最前一个',
  last_one:'已移到最后一个',
  alarmTime:'告警时间',
  queue_answer_error:'当前通话无需抢接，请直接接听',
  queue_answer_left: '请在话机上接听',
  e_broad:{
    set_emergency: '配置紧急广播',
    config:'配置',
    no_emergency:'暂无紧急广播',
    disabled: '未启用',
    enable:'启用',
    stop:'停用',
    access_pwd:'密码',
    selectOrInput:'请输入或选择'
  },
  surveillance:{
    srsTip: '请先于基本配置中完成媒体服务器地址配置'
  },
  noticeDetails:'通知记录',

}



// WEBPACK FOOTER //
// ./src/locale/lang/zh-CN.js